


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { SFacebook, STwitter, SLinkedIn } from 'vue-socials';

import SocialButton, {
  EASocialMedia
} from '@/components/molecules/SocialMediaButton/SocialMediaButton.vue';

import { copyToClipboard } from '@/utils';

export type SocialShareButtonData = {
  url: string;
  title?: string;
  text?: string;
  image?: string;
};

export type SocialShareButtonProps = {
  as: string;
  innerComponent: string;
  innerComponentClick?: () => void;
  shareOptions: Record<string, string>;
};

@Component({
  components: {
    SFacebook,
    STwitter,
    SLinkedIn,
    SocialButton
  }
})
export default class SocialShareButton extends Vue {
  @Prop() network!: EASocialMedia;
  @Prop() data!: SocialShareButtonData;

  get componentMapper(): Record<string, SocialShareButtonProps> {
    const { url, text, image = null } = this.data;

    return {
      [EASocialMedia.facebook]: {
        as: 'SFacebook',
        innerComponent: 'SocialButton',
        shareOptions: {
          url,
          ...(text && { quote: text }),
          ...(image && { image })
        }
      },
      [EASocialMedia.twitter]: {
        as: 'STwitter',
        innerComponent: 'SocialButton',
        shareOptions: {
          url,
          ...(text && { text })
        }
      },
      [EASocialMedia.linkedin]: {
        as: 'SLinkedIn',
        innerComponent: 'SocialButton',
        shareOptions: {
          url
        }
      },
      [EASocialMedia.copyLink]: {
        as: 'div',
        innerComponent: 'SocialButton',
        innerComponentClick: () => {
          this.$emit('open', this.network);

          copyToClipboard(url, () => {
            this.$notification(
              String(this.$t('common.components.socialShareButton.linkCopied'))
            );
          });
        },
        shareOptions: {
          url
        }
      },
      [EASocialMedia.more]: {
        as: 'div',
        innerComponent: 'SocialButton',
        innerComponentClick: () => {
          this.$emit('open', this.network);
        },
        shareOptions: {
          url
        }
      }
    };
  }

  get currentOptions() {
    return this.componentMapper[this.network];
  }
}
